<script>
/**
 * This view simply loads the information from the store based on a `userId`
 * then redirects to either the actual meeting, or the create view.
 *
 * This route might be removed in the near future when supporting multiple meetings
 * with the same person.
 */

import { mapGetters } from "vuex";

export default {
    props: {
        userId: {
            type: String,
            required: true,
        },
    },
    computed: {
        ...mapGetters({
            getMeetingDetails: "meetings/meetings/details",
        }),
        meeting() {
            return this.getMeetingDetails(this.userId);
        },
    },
    created() {
        if (this.meeting._id) {
            this.$router.push(`/meetings/details/${this.meeting._id}`);
        } else {
            this.$router.push(`/meetings/create`);
        }
    },
};
</script>
